import { LogFunction, LogKey } from '@bucketplace/design-system/bds';

import { setCookie } from '../cookie';
import { getDeepLink } from '../tracking';
import { handleLog } from './log';

const COOKIE_KEYS: Partial<Record<LogKey, string>> = {
  'banner.top.pc.close': 'ohsTopBannerClosed',
  'banner.top.mobile.close': 'ohsTopBannerClosed',
};

export const handleLogWithCookie: LogFunction = ({ key, category, params }) => {
  const cookie = COOKIE_KEYS[key];
  if (cookie) {
    setCookie(cookie, 'yes', 24 * 3600 * 1000);
  }

  handleLog({ key, category, params });
};

const APP_OPEN_MAP: Partial<Record<string, Parameters<typeof getDeepLink>[0]>> =
  {
    'banner.bottom.mobile.click': {
      sub_id_1: 'web_bottom_bnr',
    },
    'banner.top.mobile.click': {
      sub_id_1: 'web_top_bnr',
    },
  };

export const handleOpenApp = (type: string): void => {
  window.location.href = getDeepLink(APP_OPEN_MAP[type]);
};
